import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
import axiosInstance from "../../../../services/api/API";
import Switch from "react-switch";
import CustomTable from "../../../../customComponents/CustomTable";
//plus-circleimport Switch from "react-switch";.svg Minus-circle.svg

const JobInvoiceDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { jobCardDataDetails } = location?.state || {};
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
  const [remark, setRemark] = useState("");
  const token = localStorage.getItem("authToken");
  const [jobCardDetails, setJobCardDetails] = useState();
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const [invoiceData,setInvoiceData] = useState()
  // Add state for remark
  const [assigneeList] = useState([
    { name: "Telecaller 1", assignedLeads: 5 },
    { name: "Telecaller 2", assignedLeads: 10 },
    { name: "Telecaller 3", assignedLeads: 3 },
    { name: "Sales Manager 1", assignedLeads: 8 },
    { name: "Sales Manager 2", assignedLeads: 6 },
    { name: "Sales Manager 3", assignedLeads: 2 },
  ]);
  const [issueId, setIssueId] = useState(0);

  const Job_Card_TABLE_HEADERS = [
    "Complain",
    "Quantity",
    "Price",
    "Total_Cost",
  ];
  const BUSINESS_PARTNER_KEY_MAPPING = {
    Complain: "item_name",
    Quantity: "good_qty",
    Price: "item_total_amount",
    Total_Cost: "item_total_amount",
  };
  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoice/getjobCardPersonalDetails",
        {
          business_partner_id: jobCardDataDetails?.business_partner_id,
          job_card_id: jobCardDataDetails?.job_card_id,
          // login_user_id: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data;
      setJobCardDetails(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoice/invoiceItemComplainView",
        {
          business_partner_id: jobCardDataDetails?.business_partner_id,
          job_card_id: jobCardDataDetails?.job_card_id,
        
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

  setInvoiceData(response?.data?.data);
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
      }));
      setJobCardIssueList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const GenerateInvoiceDetails = async () => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoice/generateJobCardInvoice",
        {
          business_partner_id: jobCardDataDetails?.business_partner_id,
          job_card_id: jobCardDataDetails?.job_card_id,
          chargeable_amount:invoiceData?.SubTotal,
          tax_per:"18",
          tax_amount:invoiceData?.GstAmount,
          total_amount:invoiceData?.Total,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status == 200) {
        navigate("/manage-services/job-card-invoice");
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    if (jobCardDataDetails) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
    }
  }, []);

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer  col-xl-4 col-lg-12 mt-2 mb-2">
          <div className="backbutton mt-2 mb-2">
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Job Invoice Details</span>
          </div>
        </div>
        <div className="totalvaluescontainer col-xl-8 col-lg-12 mt-2 mb-2">
          <div
            className="downloadiconwrapper downloadIcon"
            onClick={() => GenerateInvoiceDetails()}
          >
            <h6 className="downloadTitle">Generate Invoice</h6>
          </div>
        </div>
      </div>
      <div className="invoice-container mt-3">
        <header className="invoice-header ">
          <div className="row first-row">
            <img
              src="https://html.laralink.com/invoma/assets/img/logo.svg"
              alt="Company Logo"
              className="company-logo"
            />
            <span className="invoiceheader">Invoice</span>
          </div>
          <div className="row second-row">
            <div className="payment-method">
              {/* <span className='pmtitle'>Payment Method:</span><span className='pmvalue'> Credit Card</span> */}
            </div>
            {/* <div className="invoice-info">
            <div>
            <span className='invoicenumber'>Invoice Number: </span><span className='invoicevalue'> #12345</span>
            </div>
            <div>
            <span className='invoicenumber'>Date:</span><span className='invoicevalue'> 2024-08-16</span>

            </div>
          </div>  */}
          </div>
        </header>
        <div className="addresssections">
          <section className="invoice-details">
            <div style={{ textAlign: "left" }}>
              <h2>Invoice To:</h2>
              <p className="addvalue">{jobCardDetails?.customer_name || "-"}</p>
              <p className="addvalue">
                {jobCardDetails?.address || "-"} ,
                {jobCardDetails?.bp_pincode || "-"}
              </p>

              <p className="addvalue">
                {jobCardDetails?.email_id || "-"}, <b>mo.-</b>
                {jobCardDetails?.contact_no || "-"}
              </p>
            </div>
          </section>
          <section className="invoice-details">
            <div style={{ textAlign: "right" }}>
              <h2>Pay To:</h2>
              <p className="addvalue">{jobCardDetails?.bp_name || "-"}</p>
              <p className="addvalue">{jobCardDetails?.bp_address || "-"}</p>
              <p className="addvalue">
                {jobCardDetails?.bp_state_name || "-"}-
                {jobCardDetails?.bp_city_name || "-"}-{" "}
                {jobCardDetails?.pincode || "-"}
              </p>
              <p className="addvalue">
                {jobCardDetails?.bp_email || "-"}, <b>mo.-</b>
                {jobCardDetails?.bp_contactno || "-"}
              </p>
            </div>
          </section>
        </div>
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Unit Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {(jobCardIssueList || []).map((jobcardData) => (
              <tr>
                <td>{jobcardData?.item_name || "-"}</td>
                <td>{jobcardData?.good_qty}</td>
                <td>&#8377; {jobcardData?.rate}</td>
                <td>&#8377; {jobcardData?.item_total_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <footer className="invoice-footer">
          <div className="pminfo"></div>
          <div className="total">
            <div className="totalval">
              
              <span>Subtotal:</span>
              <span>&#8377;{invoiceData?.SubTotal || '-'}</span>
            </div>
            <div className="totalval">
              <span>Tax ({invoiceData?.Gst}):</span> <span>&#8377;{Number(invoiceData?.GstAmount).toFixed(2) || '0'}</span>
            </div>
            <div className="grandtotal">
              <span>Grand Total: </span>
              <span>&#8377;{ Number(invoiceData?.Total).toFixed(2) || '0'}</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default JobInvoiceDetails;
